import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/core/service/request.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class LiffService {

  constructor(
    private requestService: RequestService
  ) { }

  GetLiffID(value:string){
    var param = {
      "CompanyID":value
    };
    return this.requestService.Post<string>(environment.baseUrl + '/Liff/GetLIFFID',param);
  }

  CheckUser(CompanyID:string,UserID:string){
    var param = {
      "CompanyID":CompanyID,
      "UserID": UserID
    };
    return this.requestService.Post<string>(environment.baseUrl + '/Liff/CheckUser',param);
  }
}
